interface PhoneObject {
  countryCode?: string;
  prefix?: string;
  number?: string;
  directDialNumber?: string | null;
}

export const formatPhone = (phone: string | PhoneObject | undefined): string => {
  if (!phone) return '';
  
  if (typeof phone === 'string') {
    return phone;
  }
  
  if (phone.directDialNumber) {
    return phone.directDialNumber;
  }
  
  const countryCode = phone.countryCode?.replace(/\s/g, '');
  const prefix = phone.prefix?.replace(/\s/g, '');
  const number = phone.number?.replace(/\s/g, '');
  
  const parts = [prefix, number].filter(Boolean);
  
  return countryCode ? `+${countryCode} ${parts.join(' ')}` : parts.join(' ');
};
